import { BlockEditProps } from "@wordpress/blocks";
import { __ } from "@wordpress/i18n";
import React from "react";
import Toggle from "../../controls/toggle/Toggle";
import Panel from "./Panel";

type props = {
	hideOnDesktop?: boolean;
	hideOnTablet?: boolean;
	hideOnMobile?: boolean;
	setAttributes: BlockEditProps<any>["setAttributes"];
	hasColReverse?: boolean;
	colReverseOnTablet?: boolean;
	colReverseOnMobile?: boolean;
};

const ResponsiveControls: React.FC<props> = (props) => {
	const {
		hideOnDesktop,
		hideOnTablet,
		hideOnMobile,
		setAttributes,
		hasColReverse = false,
		colReverseOnTablet,
		colReverseOnMobile,
	} = props;

	return (
		<Panel title={__("Responsive condition", "magazine-blocks")}>
			{hasColReverse && (
				<>
					<Toggle
						size="sm"
						checked={colReverseOnTablet || false}
						onChange={() =>
							setAttributes({
								colReverseOnTablet: !colReverseOnTablet,
							})
						}
						label={__(
							"Column Reverse on Tablet",
							"magazine-blocks"
						)}
					/>
					<Toggle
						size="sm"
						checked={colReverseOnMobile || false}
						onChange={() =>
							setAttributes({
								colReverseOnMobile: !colReverseOnMobile,
							})
						}
						label={__(
							"Column Reverse on Mobile",
							"magazine-blocks"
						)}
					/>
				</>
			)}
			<Toggle
				size="sm"
				checked={hideOnDesktop || false}
				onChange={() =>
					setAttributes({ hideOnDesktop: !hideOnDesktop })
				}
				label={__("Hide on Desktop", "magazine-blocks")}
			/>
			<Toggle
				size="sm"
				checked={hideOnTablet || false}
				onChange={() => setAttributes({ hideOnTablet: !hideOnTablet })}
				label={__("Hide on Tablet", "magazine-blocks")}
			/>
			<Toggle
				size="sm"
				checked={hideOnMobile || false}
				onChange={() => setAttributes({ hideOnMobile: !hideOnMobile })}
				label={__("Hide on Mobile", "magazine-blocks")}
			/>
		</Panel>
	);
};

export default ResponsiveControls;
